import React from 'react';
import { LoanAmountContainer, Title, Amount, Currency } from './LoanAmount.Styled';
const formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
});
export const LoanAmount = (props) => {
    const msg = props.approvedAmount ? 'Monto aprobado' : 'Monto solicitado';
    return (React.createElement(React.Fragment, null,
        React.createElement(LoanAmountContainer, null,
            React.createElement(Title, { size: props.size }, msg),
            React.createElement(Amount, { size: props.size },
                formatter.format(props.amount || 0),
                " ",
                React.createElement(Currency, null, "COP")))));
};
//# sourceMappingURL=LoanAmount.js.map